<template>
  <div class="form-view">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="form-content" :label-width="formLabelWidth">
      <p class="form-sub-title">基本信息</p>
      <el-row class="form-row" :gutter="20">
        <el-col :span="12">
          <el-form-item label="咨询教练" prop="consultCoach">
            <el-input v-model="ruleForm.consultCoach" class="input-with-select"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="行业" prop="industry">
            <el-select placeholder="行业" clearable v-model="ruleForm.industry" class="input-with-select">
              <el-option v-for="item in industrys" :label="item.name" :value="item.name" :key="item.code"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="省" prop="province">
            <el-select placeholder="省" clearable v-model="ruleForm.province" @change="provinceChange" class="input-with-select">
              <el-option v-for="(item, index) in provinces" :label="item.name" :value="item.name" :key="index"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="市" prop="city">
            <el-select placeholder="市" clearable v-model="ruleForm.city" class="input-with-select">
              <el-option v-for="(item, index) in curProvince.city" :label="item.name" :value="item.name" :key="index"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="毕业院校" prop="college ">
            <el-input v-model="ruleForm.college " class="input-with-select"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="职称" prop="jobTitle">
            <el-input v-model="ruleForm.jobTitle" class="input-with-select"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话" prop="phone">
            <el-input v-model="ruleForm.phone" class="input-with-select"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="咨询数量" prop="readerNumber">
            <el-input v-model="ruleForm.readerNumber" class="input-with-select"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="咨询费用" prop="money">
            <el-input v-model="ruleForm.money" class="input-with-select"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="专业特长" prop="businessSpecialties">
            <el-input v-model="ruleForm.businessSpecialties" type="textarea" placeholder="专业特长" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="从业经历" prop="professionalExperience">
            <el-input v-model="ruleForm.professionalExperience" type="textarea" placeholder="从业经历" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="头像" prop="urls">
            <ul class="uploadWarp">
              <li class="upli" v-for="(it, i) in ruleForm.attachmentForms" @click="showImg(i)" :key="i">
                <span class="delete el-icon-close" @click.stop="deleteImg(i)"></span>
                <el-image :src="it.url" class="avatar">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </li>
              <li class="upli" v-if="ruleForm.attachmentForms.length === 0">
                <el-upload action="" :show-file-list="false" :on-change="handleChange" ref="upload" accept="image/png, image/jpeg, image/jpg" :auto-upload="false">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </li>
            </ul>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="footer">
      <el-button type="primary" class="submit" @click="submit('ruleForm')">提交</el-button>
    </div>
    <image-viewer :visible="visible" :data="urls" :initial-index="initIdx" @close="visible = false"></image-viewer>
  </div>
</template>

<script>
import ImageViewer from '@/components/ImageViewer'
import formRules from '@/utils/rules'
import professionalApi from '@/api/professional'
import authApi from '@/api/auth'
export default {
  name: 'AddProfessional',
  props: ['rowId'],
  components: {
    ImageViewer
  },
  data () {
    return {
      rules: {
        consultCoach: [formRules.inputRequired],
        businessSpecialties: [formRules.inputRequired],
        industry: [formRules.selectRequired],
        city: [formRules.selectRequired],
        money: [formRules.inputNumber, formRules.inputRequired],
        phone: [formRules.contact],
        readerNumber: [formRules.inputNumber]
      },
      formLabelWidth: '100px',
      ruleForm: {
        city: '',
        attachmentForms: [],
        readerNumber: 0
      },
      industrys: [],
      provinces: [],
      curProvince: [],
      visible: false,
      urls: [],
      initIdx: 0
    }
  },
  methods: {
    showImg (i) {
      this.urls = this.ruleForm.attachmentForms.map(m => {
        return {
          url: m.url
        }
      })
      this.initIdx = i
      this.visible = true
    },
    deleteImg (idx) {
      this.$confirm('是否确认删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.ruleForm.attachmentForms.splice(idx, 1)
      }).catch(() => { })
    },
    handleChange (file, fileList) {
      fileList = []
      var formData = new FormData()
      formData.append('file', file.raw)
      authApi.uploadFile(formData).then(res => {
        this.ruleForm.attachmentForms.push({
          url: res.data
        })
      })
    },
    provinceChange () {
      this.curProvince = this.provinces.find(p => p.name === this.ruleForm.province)
      this.ruleForm.city = ''
    },
    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.rowId) {
            this.ruleForm.photoUrl = this.ruleForm.attachmentForms.length > 0 ? this.ruleForm.attachmentForms[0].url : ''
            professionalApi.update(this.ruleForm).then(res => {
              this.$message.success('修改成功!')
              this.$emit('action')
            })
          } else {
            this.ruleForm.photoUrl = this.ruleForm.attachmentForms.length > 0 ? this.ruleForm.attachmentForms[0].url : ''
            professionalApi.insert(this.ruleForm).then(res => {
              this.$message.success('新增成功!')
              this.$emit('action')
            })
          }
        }
      })
    },
    getIndustry (typeCode) {
      authApi.dicInfo({
        typeCode
      }).then(res => {
        this.industrys = res
      })
    },
    getProvince () {
      return authApi.selectProvince()
    }
  },
  async mounted () {
    this.getIndustry('TYPE_ONE')
    this.provinces = await this.getProvince()
    this.provinces.forEach(p => {
      if (p.city.length === 0) {
        p.city.push(p)
      } 
    })
    if (this.rowId) {
      professionalApi.queryDetailByRowId({
        rowId: this.rowId
      }).then(res => {
        this.provinces.forEach(p => {
          if (p.city.some(c => c.name === res.city)) {
            res.province = p.name
          }
        })
        if (res.photoUrl) {
          res.attachmentForms = [{
            url: res.photoUrl
          }]
        } else {
          res.attachmentForms = []
        }
        this.ruleForm = res
      })
    } 
  }
}
</script>

<style scoped lang="less">
.simpleWarp {
  float: left;
  width: 100%;
  border: 1px solid #d9ecff;
  background: #fbfdff;
  margin: 10px 0;
  .cons {
    color: #1e88e5;
    padding: 10px 0 14px 22px;
    span {
      float: right;
      border: 1px solid #63b1ff;
      background: #d5eaff;
      padding: 5px;
      cursor: pointer;
      margin: 0 20px 0 0;
      &:hover {
        background: rgba(213, 234, 255, 0.5);
      }
    }
  }
  .consList {
    width: 100%;
    overflow: hidden;
    .consIndex {
      float: right;
      border: 1px solid #ff5b36;
      background: rgba(255, 91, 54, 0.3);
      padding: 5px;
      cursor: pointer;
      margin: 10px 10px 0 0;
      &:hover {
        background: rgba(255, 91, 54, 0.5);
      }
    }
  }
}
</style>
